import { useCallback } from 'react';
import { useSnackbar } from 'notistack';

/**
 * App-wide notifications (notistack). Drop-in replacement for local showToast helpers.
 */
export default function useNotify() {
  const { enqueueSnackbar } = useSnackbar();

  const showToast = useCallback(
    (message, type = 'info') => {
      if (!message) return;
      enqueueSnackbar(String(message), {
        variant: type,
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        autoHideDuration: type === 'error' ? 5500 : 4000,
      });
    },
    [enqueueSnackbar]
  );

  return {
    showToast,
    success: (message) => showToast(message, 'success'),
    error: (message) => showToast(message, 'error'),
    info: (message) => showToast(message, 'info'),
    warning: (message) => showToast(message, 'warning'),
  };
}
